export enum AssetCodeGrade {
  New = 'new',

  Used = 'used',

  AsIs = 'as_is',

  Refurbished = 'refurbished',
}
